// local images (they need to be imported to be preloaded by the builder)
// (this is unfortunate as it makes the code less readable, but it is necessary for the builder to preload the images)
import imgPA_plants1 from "../assets/images_projarticles/20240816_131439.jpg";
import imgPA_plants2 from "../assets/images_projarticles/20240811_113450.jpg";
import imgPA_plants3 from "../assets/images_projarticles/20240715_104956.jpg";

import imgPA_raspi1 from "../assets/images_projarticles/20240715_104739.jpg";
import imgPA_raspi2 from "../assets/images_projarticles/20240811_113509.jpg";
import imgPA_raspi3 from "../assets/images_projarticles/20240811_113450.jpg";

import imgPA_windturb1 from "../assets/images_projarticles/IMG_4745.JPG";
import imgPA_windturb2 from "../assets/images_projarticles/IMG_5632.JPG";
import imgPA_windturb3 from "../assets/images_projarticles/IMG_0796.JPG";

// test images...
import imgPA_test6 from "../assets/images_projarticles/test/test1 (6).jpg";
import imgPA_test7 from "../assets/images_projarticles/test/test1 (7).jpg";
import imgPA_test8 from "../assets/images_projarticles/test/test1 (8).jpg";
import imgPA_test9 from "../assets/images_projarticles/test/test1 (9).jpg";
import imgPA_test10 from "../assets/images_projarticles/test/test1 (10).jpg";
import imgPA_test11 from "../assets/images_projarticles/test/test1 (11).jpg";
import imgPA_test12 from "../assets/images_projarticles/test/test1 (12).jpg";
import imgPA_test13 from "../assets/images_projarticles/test/test1 (13).jpg";
import imgPA_test14 from "../assets/images_projarticles/test/test1 (14).jpg";
import imgPA_test15 from "../assets/images_projarticles/test/test1 (15).jpg";
import imgPA_test16 from "../assets/images_projarticles/test/test1 (16).jpg";
import imgPA_test17 from "../assets/images_projarticles/test/test1 (17).jpg";
import imgPA_test18 from "../assets/images_projarticles/test/test1 (18).jpg";
import imgPA_test19 from "../assets/images_projarticles/test/test1 (19).jpg";
import imgPA_test20 from "../assets/images_projarticles/test/test1 (20).jpg";
import imgPA_test21 from "../assets/images_projarticles/test/test1 (21).jpg";
import imgPA_test22 from "../assets/images_projarticles/test/test1 (22).jpg";
import imgPA_test23 from "../assets/images_projarticles/test/test1 (23).jpg";
import imgPA_test24 from "../assets/images_projarticles/test/test1 (24).jpg";
import imgPA_test25 from "../assets/images_projarticles/test/test1 (25).jpg";
import imgPA_test26 from "../assets/images_projarticles/test/test1 (26).jpg";


/*

Notes about the article data structure:
- The article data is stored in a list of objects called articleList.
- Each object in the articleList represents an article.
- Each article object has the main properties for previewing the articles and a minimum content:
-- title: The title of the article.
-- shortDescription: A short description of the article.
-- image: The main image of the article.
- The article's array id and URL handle is generated from the title of the 
  article (using functions from the bottom of this file).
- The article could have additional images and paragraphs,
  which are stored in additionalImages and additionalParagraphs properties,
  and require a specific order to be displayed correctly,
  hence the article_pattern property.
* Make sure the additionalImages and additionalParagraphs arrays have the correct amount of elements
* as the article_pattern array (i.e. if 2 additional images and 2 additional paragraphs listed,
*   then the article_pattern should have 4 elements).
- The article object can have tags for projects and notable articles.
-- tags_projects: An array of project tags associated with the article 
 which can be used to list articles under the specifci project on the /projects page.
-- tag_notable: A boolean value to indicate if the article is notable or not,
 so as to be on the 'Notable' featured section on the /index page.
* Try to list newer articles at the top of the articleList array, 
* as the 'latest articles' and 'notable articles' sections will grab from the first/top of the array.

*/

// this is the article data that will implant onto the articles template page
// (this is useful as we don't need to make a new file for each article)
const articleList = [
  {
    title: "Plants Are Growing In 2024s Greenhouse",
    shortDescription: `Summer for RED means making use of the greenhouse. Given the nature of one, 
    we can expect plants that would take weeks to sprout outside to sprout here in mere days.`,
    image: imgPA_plants1,
    article_pattern: ["paragraph", "image", "paragraph", "image", "paragraph"],
    additionalImages: [imgPA_plants2, imgPA_plants3],
    additionalParagraphs: [
      `The heat trapped makes the environment about 10-15'C higher in spring, 
      while summer increase can be around 20-25'C. This is a great advantage for plants that
      require a warmer environment to grow.`,
      `The below photo shows the greenhouse only a month before, notice the massive difference
       in size for beans and tomatoes.`,
      `But with increase environmental temperature, the greenhouse can also be a dangerous place
       for plants.
      The heat can cause the plants to dry out, and shock some plants to seed prematurely.
       (See those yellow flowered canola-looking plants? Those
        are radishes that have been shocked to seed prematurely).`,
    ],
    tags_projects: ["solargreenhouse"],
    tag_notable: false,
  },
  {
    title: "The Raspberry Plants Are Growing Bits and Bytes",
    shortDescription: `This is a raspberry pi. It is a small microprocessor that can be used for a variety of purposes.
     In this case, it is being used to host the open-source OS Home Assistant which
     is used to monitor and control the greenhouse's sensors and actuators.`,
    image: imgPA_raspi1,
    article_pattern: ["paragraph", "image", "paragraph", "image", "paragraph"],
    additionalImages: [imgPA_raspi2, imgPA_raspi3],
    additionalParagraphs: [
      `The Raspberry Pi can host Home Assistant, which allows it to act as a server to monitor and control
       the greenhouse's sensors and actuators. This setup can be accessed remotely from the internet, providing
       real-time data and control capabilities.`,
      `Data collected from the sensors can be logged on a time-series historian. This allows for detailed analysis
       of environmental conditions (and system outputs) over time, helping to optimize plant growth and 
       identify any issues that may arise.`,
      `By using the Raspberry Pi and Home Assistant, the greenhouse can be monitored and controlled efficiently.
       This also gives any software or computer students a lab to experiment with.`,
    ],
    tags_projects: ["solargreenhouse"],
    tag_notable: false,
  },
  {
    title: "Cold Winds Spells Hot Wires",
    shortDescription: `The Savonius wind turbine is a type of vertical-axis wind turbine that is known for its simplicity and efficiency.
     It is particularly effective in low wind speed environments and can be used for a variety of applications.`,
    image: imgPA_windturb1,
    article_pattern: ["paragraph", "image", "paragraph", "image", "paragraph"],
    additionalImages: [imgPA_windturb2, imgPA_windturb3],
    additionalParagraphs: [
      `The Savonius wind turbine has been tested outdoors on our campus. We hope to implement a fleet of these on campus for further testing and maybe commercial use.`,
      `In addition to outdoor testing, the Savonius wind turbine has also been tested in a wind tunnel at the University of Alberta.
       These controlled tests have provided valuable data on the turbine's performance under various wind conditions.`,
      `By testing the Savonius wind turbine both outdoors and in a wind tunnel, we have been able to gather comprehensive data
       on its performance. This information will be used to further optimize the design and explore new applications for this
       versatile wind turbine.`,
    ],
    tags_projects: ["windturbine"],
    tag_notable: true,
  },
  // test articles...
  {
    title: "Harvesting Sunshine: Solar Panels in Action",
    shortDescription: `The campus is going green with the installation of new solar panels that power various projects, 
    including the greenhouse and wind turbine data collection systems.`,
    image: imgPA_test6,
    article_pattern: ["paragraph", "image", "paragraph", "image", "paragraph"],
    additionalImages: [imgPA_test7, imgPA_test8],
    additionalParagraphs: [
      `These solar panels are capable of generating up to 5 kW of power on a sunny day, enough to meet the energy needs of several small projects.`,
      `The panels are mounted on adjustable stands to maximize energy capture as the sun's angle changes throughout the day.`,
      `By integrating solar power with our other renewable energy systems, we're creating a self-sustaining environment that aligns with our mission of sustainability.`,
    ],
    tags_projects: ["solargreenhouse"],
    tag_notable: false,
  },
  {
    title: "Beneath the Surface: Aquaponics System Revealed",
    shortDescription: `Aquaponics combines aquaculture and hydroponics to create a sustainable food production system that uses fish waste as fertilizer.`,
    image: imgPA_test9,
    article_pattern: ["paragraph", "image", "paragraph", "image", "paragraph"],
    additionalImages: [imgPA_test10, imgPA_test11],
    additionalParagraphs: [
      `The aquaponics system is currently housing tilapia and growing a variety of leafy greens, such as lettuce and kale.`,
      `Water quality sensors monitor ammonia, nitrite, and nitrate levels to ensure a balanced ecosystem for both fish and plants.`,
      `This closed-loop system is an excellent model for sustainable agriculture, reducing water usage by up to 90% compared to traditional farming methods.`,
    ],
    tags_projects: ["solargreenhouse"],
    tag_notable: true,
  },
  {
    title: "Data in Bloom: IoT in the Greenhouse",
    shortDescription: `Internet of Things (IoT) devices are transforming our greenhouse into a smart ecosystem that responds to environmental changes in real time.`,
    image: imgPA_test12,
    article_pattern: ["paragraph", "image", "paragraph", "image", "paragraph"],
    additionalImages: [imgPA_test13, imgPA_test14],
    additionalParagraphs: [
      `IoT sensors monitor temperature, humidity, and soil moisture, automatically adjusting the irrigation and ventilation systems as needed.`,
      `Real-time data is accessible via Home Assistant, allowing users to make informed decisions and respond quickly to any issues.`,
      `This implementation showcases the potential of IoT in agriculture, providing a model for scalable smart farming solutions.`,
    ],
    tags_projects: ["solargreenhouse"],
    tag_notable: false,
  },
  {
    title: "Charging Ahead: Battery Storage Innovations",
    shortDescription: `Storing renewable energy effectively is key to its success, and we're testing cutting-edge battery technologies on campus.`,
    image: imgPA_test15,
    article_pattern: ["paragraph", "image", "paragraph", "image", "paragraph"],
    additionalImages: [imgPA_test16, imgPA_test17],
    additionalParagraphs: [
      `The latest lithium-iron phosphate (LiFePO4) batteries provide enhanced safety and longer lifespans compared to traditional lithium-ion batteries.`,
      `Our test setup includes both solar and wind energy inputs, demonstrating the versatility of these storage solutions.`,
      `Energy storage systems like these are critical for balancing supply and demand in renewable energy grids, ensuring reliability even on cloudy or windless days.`,
    ],
    tags_projects: ["solargreenhouse", "thermalstorage"],
    tag_notable: false,
  },
  {
    title: "Cool Solutions: Thermal Storage Techniques",
    shortDescription: `Thermal storage offers a sustainable way to regulate temperatures in renewable energy systems, minimizing energy loss.`,
    image: imgPA_test18,
    article_pattern: ["paragraph", "image", "paragraph", "image", "paragraph"],
    additionalImages: [imgPA_test19, imgPA_test20],
    additionalParagraphs: [
      `Phase-change materials (PCMs) are being tested for their ability to store excess heat during the day and release it at night.`,
      `The greenhouse benefits from thermal storage, maintaining a stable temperature and reducing the risk of extreme conditions for plants.`,
      `Future applications include integrating thermal storage with district heating systems and renewable energy plants.`,
    ],
    tags_projects: ["thermalstorage"],
    tag_notable: true,
  },
  {
    title: "Roots in the Clouds: Vertical Farming",
    shortDescription: `Our vertical farming initiative aims to maximize space efficiency while growing high-yield crops using advanced hydroponic systems.`,
    image: imgPA_test21,
    article_pattern: ["paragraph", "image", "paragraph", "image", "paragraph"],
    additionalImages: [imgPA_test22, imgPA_test23],
    additionalParagraphs: [
      `LED grow lights provide the optimal spectrum for plant growth, reducing energy consumption compared to traditional lighting.`,
      `The modular design allows for easy scaling, making this technology suitable for urban environments and food deserts.`,
      `Vertical farming is not only space-efficient but also water-efficient, consuming 90% less water than conventional farming methods.`,
    ],
    tags_projects: ["windturbine", "thermalstorage"],
    tag_notable: true,
  },
  {
    title: "Winds of Change: Hybrid Renewable Systems",
    shortDescription: `Combining solar panels and wind turbines, we're creating hybrid renewable energy systems that maximize energy production year-round.`,
    image: imgPA_test24,
    article_pattern: ["paragraph", "image", "paragraph", "image", "paragraph"],
    additionalImages: [imgPA_test25, imgPA_test26],
    additionalParagraphs: [
      `The hybrid system ensures energy generation even on cloudy, windy days or calm, sunny ones.`,
      `Data collected from these systems is used to optimize energy output and identify the best configurations for various climates.`,
      `By integrating multiple renewable energy sources, we can create a more resilient and reliable energy grid for the future.`,
    ],
    tags_projects: ["windturbine"],
    tag_notable: true,
  },
  // Add more articles as needed
];

// Generate a unique articleId from the title of the article
function generateArticleId(title) {
  return title
    .toLowerCase() // typically, web URLs are case-insensitive, but usually lowercase is preferred
    .replace(/[^a-z0-9\s-]/g, "") // Remove any non-alphanumeric characters except spaces and dashes
    .replace(/\s+/g, "-") // Replace spaces with dashes
    .trim(); // Remove any leading or trailing spaces
}

// the articleList is converted into an object with articleId as the key,
// the articleId is generated from the title of the article
// which makes the URL handle for the article
const articles = articleList.reduce((acc, article) => {
  const articleId = generateArticleId(article.title);
  acc[articleId] = article;
  return acc;
}, {});

export default articles;
